import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import NestedMenu from 'Components/UI/ContextMenu/NestedMenu';
import ArrowRight from '@material-ui/icons/ArrowRight';

const OptionWithNestedMenu = ({
  selection, classes, option, handleClose, test,
}) => {
  const [mouseOverOption, setMouseOverOption] = useState(false);
  const [mouseOverSubMenu, setMouseOverSubMenu] = useState(false);
  const menuOptionRef = useRef(null);

  const handleMouseEnter = () => {
    setMouseOverOption(true);
    setMouseOverSubMenu(false);
  };

  const handleMouseLeave = () => {
    setMouseOverOption(false);
  };

  const handleFocus = (event) => {
    if (event.target === menuOptionRef.current) {
      setMouseOverOption(true);
      setMouseOverSubMenu(false);
    }
  };

  const mouseOverSubmenu = (over) => {
    setMouseOverSubMenu(over);
  };

  return (
    <MenuItem
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      ref={menuOptionRef}
      className={classNames(classes.menuOption)}
      test={test}
    >
      <Typography
        variant="h5"
        color={'primaryGray2'}
        weight={'book'}
        noWrap
      >
        {option.label}
      </Typography>
      <ArrowRight />
      <NestedMenu
        classes={classes}
        config={option.submenu}
        open={mouseOverOption || mouseOverSubMenu}
        handleClose={handleClose}
        anchorElement={menuOptionRef?.current}
        selection={selection}
        test={option.submenu.test}
        setMouseOver={mouseOverSubmenu}
        mouseOver={mouseOverSubMenu}
      />
    </MenuItem>
  );
};

OptionWithNestedMenu.defaultProps = {
  selection: '',
  test: '',
};

OptionWithNestedMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string,
    submenu: PropTypes.object,
  }).isRequired,
  selection: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  test: PropTypes.string,
};

const ContextMenuOption = ({
  selection, classes, option, handleClose, test,
}) => {
  const submenu = option?.submenu;
  if (submenu) {
    return (
      <OptionWithNestedMenu
        selection={selection}
        classes={classes}
        option={option}
        handleClose={handleClose}
        test={test}
      />
    );
  }

  return (
    <MenuItem
      onClick={(e) => option?.onClick(e, selection, handleClose)}
      className={classNames(classes.menuOption)}
      test={test}
    >
      <Typography
        variant="h5"
        color={'primaryGray2'}
        weight={'book'}
        noWrap
      >
        {option.label}
      </Typography>
    </MenuItem>
  );
};

ContextMenuOption.defaultProps = {
  selection: '',
  test: '',
};

ContextMenuOption.propTypes = {
  classes: PropTypes.object.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  }).isRequired,
  selection: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  test: PropTypes.string,
};

export default ContextMenuOption;
